import React, { useState, useEffect } from 'react';
import { getAuth, signInWithEmailAndPassword, signInAnonymously } from 'firebase/auth';
import './Auth.css'
import { getUrlParameter, allowAnonymousAuth } from '../utilities/urlUtils';


const AuthPage = ({ onAuthSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  // Only show anonymous login button if ?anonymous=true is in URL (secret escape hatch)
  const showAnonymousButton = allowAnonymousAuth();

  useEffect(() => {
    // Extract the email parameter from the URL
    const emailFromUrl = getUrlParameter('email');

    if (emailFromUrl) {
      setEmail(emailFromUrl); // Pre-fill the email input with the value from the URL
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const idToken = await user.getIdToken();
      onAuthSuccess(idToken);
    } catch (error) {
      console.error('Error signing in:', error);
      setError('Failed to sign in');
      // No need to clear localStorage token as we rely on Firebase auth persistence
    }
  };

  const handleAnonymousLogin = async () => {
    const auth = getAuth();
    try {
      const userCredential = await signInAnonymously(auth);
      const user = userCredential.user;
      const idToken = await user.getIdToken();
      onAuthSuccess(idToken);
    } catch (error) {
      console.error('Error signing in anonymously:', error);
      setError('Failed to sign in anonymously');
    }
  };

  return (
    <div className="authentication">
        <img src="/logo_white.svg" alt="Logo" className="logo" /> {/* Add the SVG logo here */}

      <h2>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <button type="submit">Login</button>
      </form>

      {/* Only show anonymous button if ?anonymous=true is in URL */}
      {showAnonymousButton && (
        <>
          <br/>
          or
          <br/>
          <button onClick={handleAnonymousLogin}>Login Anonymously</button>
        </>
      )}

      <br/>
      <p>Don't have an account? Contact us at alexa@francoflex.com</p>
    </div>
  );
};

export default AuthPage;